import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnimateComponent } from '@app/components/animate/animate.component';

@Component({
  selector: 'app-receipt-dialog',
  templateUrl: './receipt-dialog.component.html',
  styleUrls: ['./receipt-dialog.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage, ReactiveFormsModule, AnimateComponent],
})
export class ReceiptDialogComponent {
  private readonly _ngbActiveModal: NgbActiveModal = inject(NgbActiveModal);
  public close(): void {
    this._ngbActiveModal.close();
  }
}
